var _excluded = ["fontSize", "children", "qa", "color"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import styled from 'styled-components';
import Container from "./styles";
var Headline = styled(Container).withConfig({
  displayName: "Text__Headline",
  componentId: "sc-slxrr0-0"
})(["color:", ";font-weight:", ";", ""], function (props) {
  return props.theme.colors.text.headline;
}, function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.theme.typography[400];
});
var SubHeadline = styled(Container).withConfig({
  displayName: "Text__SubHeadline",
  componentId: "sc-slxrr0-1"
})(["color:", ";font-weight:", ";", ""], function (props) {
  return props.theme.colors.text.headline;
}, function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.theme.typography[300];
});
var SmallSubHeadline = styled(Container).withConfig({
  displayName: "Text__SmallSubHeadline",
  componentId: "sc-slxrr0-2"
})(["color:", ";font-weight:", ";", ""], function (props) {
  return props.theme.colors.text.headline;
}, function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.theme.typography[200];
});
var Byline = styled(Container).withConfig({
  displayName: "Text__Byline",
  componentId: "sc-slxrr0-3"
})(["color:", ";", ""], function (props) {
  return props.theme.colors.text.subtext;
}, function (props) {
  return props.theme.typography[200];
});
var SmallByline = styled(Container).withConfig({
  displayName: "Text__SmallByline",
  componentId: "sc-slxrr0-4"
})(["color:", ";", ""], function (props) {
  return props.theme.colors.text.subtext;
}, function (props) {
  return props.theme.typography[100];
});
var BodyCopy = styled(Container).withConfig({
  displayName: "Text__BodyCopy",
  componentId: "sc-slxrr0-5"
})(["color:", ";", ""], function (props) {
  return props.theme.colors.text.body;
}, function (props) {
  return props.theme.typography[300];
});
var SmallBodyCopy = styled(Container).withConfig({
  displayName: "Text__SmallBodyCopy",
  componentId: "sc-slxrr0-6"
})(["color:", ";", ""], function (props) {
  return props.theme.colors.text.body;
}, function (props) {
  return props.theme.typography[200];
});
var Text = function Text(_ref) {
  var fontSize = _ref.fontSize,
    children = _ref.children,
    qa = _ref.qa,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var qaText = typeof children === 'string' ? children : undefined;
  return /*#__PURE__*/React.createElement(Container, _extends({
    typeScale: fontSize,
    "data-qa-text": qaText
    // TODO: fix this type since `color` should be valid here. TS can't resolve the correct type.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    color: color
  }, qa, rest), children);
};
Headline.displayName = 'Text.Headline';
SubHeadline.displayName = 'Text.SubHeadline';
SmallSubHeadline.displayName = 'Text.SmallSubHeadline';
Byline.displayName = 'Text.Byline';
SmallByline.displayName = 'Text.SmallByline';
BodyCopy.displayName = 'Text.BodyCopy';
SmallBodyCopy.displayName = 'Text.SmallBodyCopy';
Text.Headline = Headline;
Text.SubHeadline = SubHeadline;
Text.SmallSubHeadline = SmallSubHeadline;
Text.Byline = Byline;
Text.SmallByline = SmallByline;
Text.BodyCopy = BodyCopy;
Text.SmallBodyCopy = SmallBodyCopy;
export default Text;